<template>
	<div class="index">
		<div class="container clearfix">
			<div class="path">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				  	<el-breadcrumb-item>下载中心</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<ul>
				<li v-for="item in dataList">
					<div class="box clearfix">
						<div class="box-left">
							<p style="font-size:18px;">{{item.title}}</p>
							<p style="font-size:13px;">
								<span><i class="el-icon-download"></i>下载量：<span>{{item.countNum}}</span></span>
								<span><i class="el-icon-info"></i>文件大小：<span>{{item.fileSize}}</span></span>
							</p>
						</div>
						<div class="box-right">
							<a :href="item.fileUrl" target="_blank">
							<el-button type="primary">
								<i class="el-icon-download" style="font-size:15px;margin-right:2px;"></i>下载
							</el-button>
							</a>
						</div>
					</div>
				</li>
			</ul>
			<div class="pages">
				<el-pagination
		            @current-change="handleCurrentChange"
					background
					layout="prev, pager, next"
					v-if="total>1?true:false"
					:total="total"
					pagesize="10"
					style="float:right">
				</el-pagination>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		name:'',
		components:{},
		data(){
			return{
				dataList:[],
				total:1,
				currentPage:1,
			}
		},
		methods:{
			handleCurrentChange: function(currentPage){
                this.currentPage = currentPage;
                this.getData();
	        },
			getData(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.downLoadListApi+'/page/'+this.currentPage,
					data: {},
				})
				.then((res) => {
					this.dataList = res.data.data;
					this.total = parseInt(res.data.total);
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getData();
		}
	}
</script>

<style lang="less" scoped="scoped">
.index{
	background-color:#eee;
	.container{
		.path{
			margin-top: 20px;
			margin-bottom: 20px;
			i{
				font-size: 20px;
			}
			span{
				color: #00A0FF;
			}
		}
		ul{
			margin-bottom:40px;
			li{
				width:100%;
				margin:20px 0px;
				background-color:#fff;
				.box{
					width:100%;
					padding:10px 30px;
					p,span,i{
						cursor:default;
					}
					.box-left{
						width:85%;
						float:left;
						p{
							margin:10px 0;
							overflow:hidden;
							white-space:nowrap;
							text-overflow:ellipsis;
							span{
								color:#c8c8c8;
								margin-right:20px;
								span{
									font-size:14px;
									color:#969696;
								}
								i{
									font-size:16px;
									margin-right:5px;
								}
							}
						}
					}
					.box-right{
						width:15%;
						float:left;
						button{
							margin-top:15px;
							float:right;
						}
					}
				}
			}
			li:hover{
				box-shadow:0 0 10px #ddd;
				transform:scale(1.02,1.02);
			}
		}
		
	}
}
.clearfix:after {
	content: ".";
	display: block;
	height: 0;
	font-size: 0;
	clear: both;
	visibility: hidden;
}
.clearfix {
	zoom: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/DownLoad/DownLoad.vue